import SavedFiltersPopUp from '@/components/shared/SavedFiltersPopUp';
import { useGlobalFilters } from '@/hooks/useGlobalFilters';
import { ApiProvider } from '@/provider/ApiProvider';
import { headerCountryListBody } from '@/CommonApis/useCountryList';
import { homePath } from '@/auth/landing';
import {
  DATA_MARKET_LABEL_KEY,
  DATA_MARKET_TOOLTIP_KEY,
  isDataMarketPage,
} from '@/auth/dataMarket';
import { useTranslation } from 'react-i18next';
import { isInternalContext } from '@/utils/userRole';
import { rangeConfig } from '@/utils/dates';
import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Slider from '@mui/material/Slider';
import { endOfYear, format, startOfYear, subMonths, subYears } from 'date-fns';

import { GlobalSearchBar } from '@/components/shared/Header/GlobalSearchBar';
import SidebarLink from '@/components/shared/Sidebar/SidebarLink';
import { linkWithBGStyles, searchContainerStyles } from '@/components/shared/Sidebar/styles';
import GlobalDateRangePicker from '@/components/shared/GlobalDateRangePicker';
import {
  AdvancedFilterOption,
  HeaderAdvancedFilters,
} from '@/components/styled/HeaderAdvancedFilters';
import MultiSelectBox from '@/components/styled/MultiSelectBox';
import { useSidebarNavigation } from '@/contexts/sidebarNavigationContext';
import { useUserData } from '@/hooks/useUserData';
import { fetchBenchmarkGroups } from '@/queries/benchmarkGroup';
import {
  ArrowDropDown as ArrowDropDownIcon,
  CalendarToday as CalendarIcon,
  FilterAlt as FilterAltIcon,
  Home as HomeIcon,
  Replay as ReplayIcon,
  Save as SaveIcon,
} from '@mui/icons-material';
import { TextField, Tooltip, Typography } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/system/Box';
import startOfMonth from 'date-fns/startOfMonth';
import React, { useEffect, useState, useRef } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { useLocation } from 'react-router-dom';
import { getHeaderBrandId, getHeaderFilters, setHeaderFilters } from '@/selection/headerSelection';
import { listOf } from '@/components/shared/AccessState/accessAnswer';
import { fetchHeaderCountries } from '@/components/shared/shellRequests';


function HeaderFilters({ onChangeFilters = () => { } }) {
  const minYob = 1950;
  const maxYob = new Date().getFullYear();
  const [filterCurrency, setFilterCurrency] = useState([]);
  const [currency_value, setCurrency_value] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [countryValue, setCountryValue] = useState([]);
  const [brand_list, setbrand_List] = useState([]);
  const [brandValue, setBrandValue] = useState([]);
  const [property_list, setProperty_List] = useState([]);
  const [propertyValue, setPropertyValue] = useState([]);
  const [activationtype_list, setActivationtype_List] = useState([]);
  const [activationtypeValue, setActivationtypeValue] = useState([]);
  const [yearRange, setYearRange] = React.useState([minYob, maxYob]);
  const [activationSubtype_list, setActivationSubtype_list] = useState([]);
  const [activationSubTouchpointList, setActivationSubTouchpointList] = useState([]);
  const [activationAssetList, setActivationAssetList] = useState([]);
  const [activationItemList, setActivationItemList] = useState([]);
  const [activationSubypeValue, setActivationSubypeValue] = useState([]);
  const [activationSubTouchpointValue, setActivationSubTouchpointValue] = useState([]);
  const [activationAssetValue, setActivationAssetValue] = useState([]);
  const [activationItemValue, setActivationItemValue] = useState([]);
  const [activationMedium_list, setActivationMedium_list] = useState([]);
  const [activationMediumValue, setActivationMediumValue] = useState([]);
  const [activationSegment_List, setActivationSegment_List] = useState([]);
  const [dqsList, setDqsList] = useState([]);
  const [dqsValue, setDqsValue] = useState([]);
  const [genderList, setGenderList] = useState([]);
  const [genderValue, setGenderValue] = useState([]);
  const [activationSegmentValue, setActivationSegmentValue] = useState([]);
  const [contextualizationValue, setContextualizationValue] = useState([]);
  const [region_list, setRegionList] = useState([]);
  const [regionValue, setRegionValue] = useState([]);
  const [city_list, setCity_list] = useState([]);
  const [cityValue, setCityValue] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [toggleFilterName, setToggleFilterName] = useState(false);
  const [filterarrayValue, setFilterarrayValue] = useState([]);
  const [prevFilterArray, setPrevFilterArray] = useState([]);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [dateRange, setDateRange] = useState([startOfYear(new Date()), new Date()]);
  const [contetualizationDateRange, setContetualizationDateRange] = useState([
    oneDayAgoNew,
    oneDayAgoNew,
  ]);
  const [contetualizationBenchmark, setContetualizationBenchmark] = useState(null);
  const [benchmarkGroupsList, setBenchmarkGroupsList] = useState([]);
  const [afterDateDisable, setAfterDateDisable] = useState(oneDayAgoNew);
  const [regionSearchQuery, setRegionSearchQuery] = useState('');
  const [citySearchQuery, setCitySearchQuery] = useState('');
  const [propertySearchQuery, setPropertySearchQuery] = useState('');
  const [brandSearchQuery, setBrandSearchQuery] = useState('');
  const { pageTabName } = useSidebarNavigation();
  const location = useLocation();
  const currentPagePath = location.pathname;
  const currentPageName = currentPagePath.split('/')[1];
  const currentTabName = pageTabName;
  const { t } = useTranslation('common');
  // D8: on contract data pages the country is an authorization filter ("Data market")
  const countryIsDataMarket = isDataMarketPage(currentPagePath, currentTabName);
  const headerLeftOffset = 65;
  const headerWidth = `calc(100% - ${headerLeftOffset}px)`;
  const brandPage = useRef(1);
  const brandLoadStatus = useRef(true);
  const hasMoreBrand = useRef(true);

  const { updateGlobalFilters, isCityRegionEnabled, isSingleBrandPage } = useGlobalFilters();
  useUserData(); // re-render on a user / role change (home link below)

  const homeModule = ApiProvider.returnUserData()?.home_module ?? null;

  // The ACTIVE assignment's landing page (context type + context id, H4).
  const homePageUrl = homePath(homeModule);

  const animateHeartBeat = JSON.stringify(filterarrayValue) !== JSON.stringify(prevFilterArray);

  //Page-wise display filters list Starts.
  const displayFiltersList = {
    brandprofile: {
      portfolio: [],
      advocacy: ['Region', 'City'],
      activation: [
        'Activity Type',
        'Touchpoint',
        'Sub-Touchpoint',
        'Asset',
        'Item',
        'Activity Medium',
        'Consumer Segment',
      ],
      consumers: [],
      Contracts: [],
      others: [],
      playbook: [],
      scouting: ['Gender', 'Year of Birth'],
    },
    partnerProfile: {
      insight: [],
      marketability: [],
      assets: [],
      Advocacy: ['Region', 'City'],
      activation: [
        'Activity Type',
        'Touchpoint',
        'Sub-Touchpoint',
        'Asset',
        'Item',
        'Activity Medium',
        'Consumer Segment',
      ],
      fans: [],
      roo: [
        'Activity Type',
        'Touchpoint',
        'Sub-Touchpoint',
        'Asset',
        'Item',
        'Activity Medium',
        'Consumer Segment',
        'Region',
        'City',
      ],
      Contracts: [],
    },
  };
  //Page-wise display filters list ends.

  // return Display Status Starts
  const returnDisplayStatus = (filterName) => {
    const filterArray = displayFiltersList[currentPageName]?.[currentTabName] || [];
    return currentTabName && filterArray.includes(filterName);
  };
  // return Display Status Ends

  const totalFilterVal =
    currency_value.length +
    countryValue.length +
    (isSingleBrandPage ? 0 : brandValue.length) +
    propertyValue.length +
    (returnDisplayStatus('Activity Type') ? activationtypeValue.length : 0) +
    (returnDisplayStatus('Touchpoint') ? activationSubypeValue.length : 0) +
    (returnDisplayStatus('Sub-Touchpoint') ? activationSubTouchpointValue.length : 0) +
    (returnDisplayStatus('Asset') ? activationAssetValue.length : 0) +
    (returnDisplayStatus('Item') ? activationItemValue.length : 0) +
    (returnDisplayStatus('Activity Medium') ? activationMediumValue.length : 0) +
    (returnDisplayStatus('Consumer Segment') ? activationSegmentValue.length : 0) +
    dqsValue.length +
    (returnDisplayStatus('Gender') ? genderValue.length : 0) +
    (returnDisplayStatus('Year of Birth') ? yearRange.length : 0) +
    (returnDisplayStatus('Region') ? regionValue.length : 0) +
    contextualizationValue.length +
    (returnDisplayStatus('City') ? cityValue.length : 0);

  const isRegionDisabled = !countryValue.length;
  const isCityDisabled = !regionValue.length;
  // DQS filter: internal contexts only (UI only; the server applies the scope, H6).
  const isDqsDisabled = !isInternalContext();

  // Default starter filters, date as Year To Date and currency as user's default currency
  const dateDefaultFilters = [
    { filter_type: 'from', name: format(startOfYear(new Date()), 'MM/dd/yyyy') },
    { filter_type: 'to', name: format(new Date(), 'MM/dd/yyyy') },
  ];

  const userCurrency = ApiProvider.returnUserData()?.currency;
  const currencyDefaultFilter = userCurrency
    ? [
      {
        ...userCurrency,
        label: userCurrency.currency_code,
        value: userCurrency?.id,
        filter_type: 'currency',
      },
    ]
    : [];

  const defaultFilters = [...dateDefaultFilters, ...currencyDefaultFilter];

  const handleChangeDateRange = (dateRange) => {
    setDateRange(dateRange);

    let oneDayAgo = new Date(dateRange[0].getTime() - 24 * 60 * 60 * 1000);
    setContetualizationDateRange([oneDayAgo, oneDayAgo]);
    setAfterDateDisable(oneDayAgo);

    const newDatesLocalStorageFormat = [
      { filter_type: 'from', name: format(dateRange[0], 'MM/dd/yyyy') },
      { filter_type: 'to', name: format(dateRange[1], 'MM/dd/yyyy') },
    ];

    const filtersWithoutDate = filterarrayValue
      .filter((el) => el.filter_type !== 'from')
      .filter((el) => el.filter_type !== 'to');

    const newFilters = [...filtersWithoutDate, ...newDatesLocalStorageFormat];

    setHeaderFilters(newFilters);

    setFilterarrayValue(newFilters);
  };

  const handleChangeContetualizationDateRange = (dateRange) => {
    setContetualizationDateRange(dateRange);

    const newDatesLocalStorageFormat = [
      { filter_type: 'contetualizationFromDate', name: format(dateRange[0], 'MM/dd/yyyy') },
      { filter_type: 'contetualizationToDate', name: format(dateRange[1], 'MM/dd/yyyy') },
    ];

    const filtersWithoutDate = filterarrayValue
      .filter((el) => el.filter_type !== 'contetualizationFromDate')
      .filter((el) => el.filter_type !== 'contetualizationToDate');

    const newFilters = [...filtersWithoutDate, ...newDatesLocalStorageFormat];

    setHeaderFilters(newFilters);

    setFilterarrayValue(newFilters);
  };

  const BrandBenchmarkGroupsChange = (event, value) => {
    if (value) {
      setContetualizationBenchmark(value);
      let item = value;
      item['filter_type'] = 'contetualizationBenchMark';

      const newBenchmarkStorageFormat = [item];

      const filtersWithoutBenchmark = filterarrayValue.filter(
        (el) => el.filter_type !== 'contetualizationBenchMark',
      );

      const newFilters = [...filtersWithoutBenchmark, ...newBenchmarkStorageFormat];

      setHeaderFilters(newFilters);

      setFilterarrayValue(newFilters);
    } else {
      setContetualizationBenchmark(null);
      const filtersWithoutBenchmark = filterarrayValue.filter(
        (el) => el.filter_type !== 'contetualizationBenchMark',
      );

      const newFilters = filtersWithoutBenchmark;

      setHeaderFilters(newFilters);

      setFilterarrayValue(newFilters);
    }
  };

  const handleAdvancedFiltersToggleClick = () => {
    setShowAdvancedFilters((prev) => !prev);
  };

  const updateFilterArray = (filterArray, filterType, date) => {
    const index = filterArray.findIndex((el) => el.filter_type === filterType);
    const newItem = { filter_type: filterType, name: format(date, 'MM/dd/yyyy') };
    if (index < 0) {
      filterArray.push(newItem);
    } else {
      filterArray[index] = newItem;
    }
  };

  const handleRangeSelect = (rangeLabel) => {
    const config = rangeConfig[rangeLabel] || rangeConfig['Default'];
    const startDate = config.startDate;
    const endDate = config.endDate;

    const filterArrayValueCopy = [...filterarrayValue];
    updateFilterArray(filterArrayValueCopy, 'from', startDate);
    updateFilterArray(filterArrayValueCopy, 'to', endDate);

    setFilterarrayValue(filterArrayValueCopy);
    setHeaderFilters(filterArrayValueCopy);
    setDateRange([startDate, endDate]);
    let oneDayAgo = new Date(startDate.getTime() - 24 * 60 * 60 * 1000);
    setContetualizationDateRange([oneDayAgo, oneDayAgo]);
    setAfterDateDisable(oneDayAgo);
  };

  //Currency
  const currencyValue = () => {
    const commondata = ApiProvider.getMasterData();
    if (commondata != '') {
      if (commondata?.comman?.currency) {
        const currency = commondata.comman.currency;
        const arrCurrency = [];
        currency.forEach(function (value) {
          const items = value;
          items['label'] = value.currency_code;
          items['value'] = value.id;
          items['filter_type'] = 'currency';
          arrCurrency.push(items);
        });

        const data1 = getHeaderFilters() ?? [];

        const curencyArray = data1.filter(function (el) {
          return el.filter_type == 'currency';
        });

        if (curencyArray.length == 0) {
          if (
            ApiProvider.returnUserData()?.currency_id &&
            ApiProvider.returnUserData()?.currency_id != null
          ) {
            const check = arrCurrency.findIndex(
              (el) => el.id == ApiProvider.returnUserData()?.currency_id,
            );
            setCurrency_value([arrCurrency[check]]);
          } else {
            const check1 = arrCurrency.findIndex((el) => el.currency_code == 'USD');
            setCurrency_value([arrCurrency[check1]]);
          }
        }

        const desiredCurrencies = ['USD', 'EUR', 'CHF'];

        const filteredDesired = arrCurrency.filter((item) =>
          desiredCurrencies.includes(item.currency_code),
        );
        const filteredExcluded = arrCurrency.filter(
          (item) => !desiredCurrencies.includes(item.name),
        );
        const orderedList = filteredDesired.concat(filteredExcluded);

        setFilterCurrency(orderedList);
      }
    }
  };

  const CurrencyChange = (value) => {
    if (!value || !value.length) {
      return ApiProvider.globalToastMessage(
        'At least 1 currency should be selected.',
        5000,
        'info',
      );
    }

    const dif1 = value.filter((x) => !currency_value.includes(x));
    let filterarrayValue1 = filterarrayValue;
    filterarrayValue1 = filterarrayValue1.filter(function (el) {
      return el.filter_type != 'currency';
    });
    dif1.forEach(function (value1) {
      filterarrayValue1.push(value1);
    });
    setFilterarrayValue(filterarrayValue1);
    setHeaderFilters(filterarrayValue1);
    setCurrency_value(dif1);
  };

  const currencyfltOptions = filterCurrency.filter(
    (option) => !currency_value.some((selected) => selected.value === option.value),
  );

  //Country
  const getCountryList = () => {
    // every country, not only the scope's (owner 2026-10-12); contracts stay limited by the server
    const body = headerCountryListBody();
    // the same request on every page: asked once per session (slow pages U3)
    fetchHeaderCountries(body).then((response) => {
      if (response.success === false) return;

      const country = response.data;
      const arrCountry = [];
      if (country && country.length > 0) {
        country.forEach(function (value) {
          // a copy: the answer is shared with the next pages
          const items = { ...value };
          items['label'] = value.name;
          items['value'] = value.id;
          items['filter_type'] = 'country';
          arrCountry.push(items);
        });
      }
      setCountryList(arrCountry);
    });
  };

  const CountryChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'country';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setCountryValue(value);
    } else {
      setCountryValue([]);
    }
  };

  const countryfltOptions = countryList.filter(
    (option) => !countryValue.some((selected) => selected.value === option.value),
  );

  // get benchmark API
  const getBenchmark = () => {
    let brand_id = undefined;
    if (currentPageName == 'brandprofile') {
      brand_id = currentPagePath.split('/')[2];
    }

    let property_id = undefined;
    if (currentPageName == 'partnerProfile') {
      property_id = currentPagePath.split('/')[2];
    }

    if (!brand_id) {
      // No client-side brand list: the server limits the groups to the
      // active scope (part 7; the old `BrandAccess` list is gone).
      fetchBenchmarkGroups({
        propertyId: property_id,
        type: 'property',
      }).then(
        (response) => {
          if (response.success == true) {
            setBenchmarkGroupsList(response.data.benchmarks);
          } else {
            setBenchmarkGroupsList([]);
          }
        },
        (error) => {
          setBenchmarkGroupsList([]);
          ApiProvider.globalToastMessage(error, 5000, 'error');
          return;
        },
      );
    } else {
      fetchBenchmarkGroups({
        brandIds: brand_id ? [brand_id] : [],
        type: 'brand',
      }).then(
        (response) => {
          if (response.success == true) {
            setBenchmarkGroupsList(response.data.benchmarks);
          } else {
            setBenchmarkGroupsList([]);
          }
        },
        (error) => {
          setBenchmarkGroupsList([]);
          ApiProvider.globalToastMessage(error, 5000, 'error');
          return;
        },
      );
    }
  };

  //Brand
  const get_Brand_List = (page, signal = undefined) => {
    brandLoadStatus.current = false;

    ApiProvider.webserviceGet(
      'Brands/GetBrands?term=' +
      encodeURIComponent(brandSearchQuery) +
      '&page=' +
      page,
      null,
      signal
    )
      .then((response) => {
        if (response?.success === false || !response?.data?.results) return;

        hasMoreBrand.current = response?.data?.pagination?.more;

        const arrBrand = response.data.results.map((value) => ({
          ...value,
          label: value.name,
          value: value.id,
          filter_type: 'brand',
        }));

        setbrand_List((prev) =>
          page === 1 ? arrBrand : [...prev, ...arrBrand]
        );

        brandLoadStatus.current = true;
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          console.error(error);
        }
      });
  };

  useEffect(() => {
    const controller = new AbortController();

    brandPage.current = 1;

    get_Brand_List(
      brandPage.current,
      controller.signal
    );

    return () => {
      controller.abort();
    };
  }, [brandSearchQuery]);

  const loadMoreBrandOptions = () => {
    if (brandLoadStatus.current && hasMoreBrand.current) {
      brandPage.current += 1;
      get_Brand_List(brandPage.current);
    }
  };

  const BrandChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'brand';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setBrandValue(value);
    } else {
      setBrandValue([]);
    }
  };

  const brandfltOptions = brand_list.filter(
    (option) => !brandValue.some((selected) => selected.value === option.value),
  );

  //Property
  const [propertyOffset, setPropertyOffset] = useState(0);
  const [propertyHasMore, setPropertyHasMore] = useState(true);
  const [propertyIsLoading, setPropertyIsLoading] = useState(false);
  const propertyPageLimit = 20;

  // Fetches a page of properties. When resetData is true, the results
  // replace the current list (initial load / new search term). Otherwise
  // results are appended, which is how additional pages are loaded as the
  // user scrolls the dropdown, so accessible right holders/partners beyond
  // the first page become reachable without requiring a search.
  const getPropertyList = (resetData, term, signal = undefined) => {
    if (propertyIsLoading || (!propertyHasMore && !resetData)) return;

    setPropertyIsLoading(true);

    let body = new FormData();

    const localStorageBrand = getHeaderBrandId();
    if (localStorageBrand) body.append('brand_id', localStorageBrand);

    if (term && term != '') {
      body.append('term', term);
    }
    const currentOffset = resetData ? 0 : propertyOffset;
    body.append('offset', currentOffset);
    body.append('limit', propertyPageLimit);
    body.append('with_suggestions', '1'); //true

    ApiProvider.webservicePostToken('Property/GetPropertyList', body, 'yes', signal).then(
      (response) => {
        setPropertyIsLoading(false);
        if (response.success === false) return;
        if (response?.data?.results) {
          const propertylist = response.data.results;
          const totalCount = response.data.pagination?.total || 0;
          const arrProperty = [];
          propertylist.forEach(function (value) {
            const items = value;
            items['label'] = value.full_name;
            items['value'] = value.id;
            items['filter_type'] = 'property';
            arrProperty.push(items);
          });

          setPropertyHasMore(currentOffset + arrProperty.length < totalCount);

          if (resetData) {
            setProperty_List(arrProperty);
            setPropertyOffset(arrProperty.length);
          } else {
            setProperty_List((prev) => {
              const existingIds = new Set(prev.map((item) => item.id));
              const uniqueNewItems = arrProperty.filter((item) => !existingIds.has(item.id));
              return [...prev, ...uniqueNewItems];
            });
            setPropertyOffset((prev) => prev + arrProperty.length);
          }
        }
      },
      () => {
        setPropertyIsLoading(false);
      },
    );
  };

  const loadMorePropertyOptions = () => {
    getPropertyList(false, propertySearchQuery);
  };

  const PropertyChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'property';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setPropertyValue(value);
    } else {
      setPropertyValue([]);
    }
  };

  const propertyfltOptions = property_list.filter(
    (option) => !propertyValue.some((selected) => selected.value === option.value),
  );

  const getDqsValues = () => {
    const commomdata = ApiProvider.getMasterData();
    if (commomdata) {
      const dbsItems = commomdata?.dbs?.dbs_datasource_classification ?? [];
      const arrDqs = [];
      dbsItems.forEach(function (value) {
        const items = value;
        items['label'] = value.name;
        items['value'] = value.id;
        items['filter_type'] = 'dqs';
        arrDqs.push(items);
      });
      setDqsList(arrDqs);
    }
  };

  const getGenderValues = () => {
    const commomdata = ApiProvider.getMasterData();
    if (commomdata) {
      const genderItems = commomdata?.comman?.gender ?? [];
      const arrGender = [];
      genderItems.forEach(function (value) {
        const items = value;
        items['label'] = value.gender;
        items['value'] = value.id;
        items['filter_type'] = 'gender';
        arrGender.push(items);
      });
      setGenderList(arrGender);
    }
  };

  const filterSubTouchpoint = (items, touchpointAarry) => {
    const uniqueItems = items.filter((item) =>
      touchpointAarry.some((touchpoint) => touchpoint.id === item.social_media_platform_id),
    );
    return uniqueItems;
  };

  const removeDuplicates = (items) => {
    const uniqueItems = items.filter(
      (item, index, self) => index === self.findIndex((t) => t.id === item.id),
    );
    return uniqueItems;
  };

  const getActivationFiltersValues = () => {
    const commomdata = ApiProvider.getMasterData();
    if (commomdata) {
      const activationTypeItens = commomdata?.activation?.aactivation_type?.results ?? [];
      const arrActivationType = [];
      activationTypeItens.forEach(function (value) {
        const items = value;
        items['label'] = value.name;
        items['value'] = value.id;
        items['filter_type'] = 'activationType';
        arrActivationType.push(items);
      });
      setActivationtype_List(arrActivationType);

      const activationSubtypeItems = commomdata?.activation?.activation_sub_type?.results ?? [];
      const arrActivationSubType = [];
      activationSubtypeItems.forEach(function (value) {
        const items = value;
        items['label'] = value.name;
        items['value'] = value.id;
        items['filter_type'] = 'activationSubtype';
        arrActivationSubType.push(items);
      });
      setActivationSubtype_list(arrActivationSubType);

      const activationSubTouchpointItems =
        commomdata?.activation?.activation_activity_type?.results ?? [];
      const arrActivationSubTouchpoint = [];
      activationSubTouchpointItems.forEach(function (value) {
        const items = value;
        items['label'] = value.name;
        items['value'] = value.id;
        items['filter_type'] = 'activationSubTouchpoint';
        arrActivationSubTouchpoint.push(items);
      });
      setActivationSubTouchpointList(arrActivationSubTouchpoint);

      const activationAssetItems = commomdata?.comman?.assetValues ?? [];
      const arrActivationAsset = [];
      activationAssetItems.forEach(function (value) {
        const items = value;
        items['label'] = value.name;
        items['value'] = value.id;
        items['filter_type'] = 'activationAsset';
        arrActivationAsset.push(items);
      });
      setActivationAssetList(arrActivationAsset);

      const activationItemItems = commomdata?.comman?.itemValues ?? [];
      const arrActivationItem = [];
      activationItemItems.forEach(function (value) {
        const items = value;
        items['label'] = value.name;
        items['value'] = value.id;
        items['filter_type'] = 'activationItem';
        arrActivationItem.push(items);
      });
      setActivationItemList(arrActivationItem);

      const activationMediumItens = commomdata?.activation?.activation_medium?.results ?? [];
      const arrActivationMedium = [];
      activationMediumItens.forEach(function (value) {
        const items = value;
        items['label'] = value.name;
        items['value'] = value.id;
        items['filter_type'] = 'activationMedium';
        arrActivationMedium.push(items);
      });
      setActivationMedium_list(arrActivationMedium);

      const consumerSegmentItens =
        commomdata?.activation?.activation_consumer_segment?.results ?? [];
      const arrActivationSegment = [];
      consumerSegmentItens.forEach(function (value) {
        const items = value;
        items['label'] = value.name;
        items['value'] = value.id;
        items['filter_type'] = 'consumerSegment';
        arrActivationSegment.push(items);
      });
      setActivationSegment_List(arrActivationSegment);
    }
  };

  const ActivationTypeChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'activationType';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setActivationtypeValue(value);
    } else {
      setActivationtypeValue([]);
    }
  };

  const ActivationSubTypeChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'activationSubtype';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setActivationSubypeValue(value);
    } else {
      setActivationSubypeValue([]);
    }
    // activationSubTouchpointChange([]);
  };

  const activationSubTouchpointChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'activationSubTouchpoint';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setActivationSubTouchpointValue(value);
    } else {
      setActivationSubTouchpointValue([]);
    }
  };

  const activationAssetChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'activationAsset';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setActivationAssetValue(value);
    } else {
      setActivationAssetValue([]);
    }
  };

  const activationItemChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'activationItem';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setActivationItemValue(value);
    } else {
      setActivationItemValue([]);
    }
  };

  const ActivationMediumChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'activationMedium';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setActivationMediumValue(value);
    } else {
      setActivationMediumValue([]);
    }
  };

  const ActivationSegmentChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'consumerSegment';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setActivationSegmentValue(value);
    } else {
      setActivationSegmentValue([]);
    }
  };

  const dqsChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'dqs';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setDqsValue(value);
    } else {
      setDqsValue([]);
    }
  };

  const genderChange = (value) => {
    if (value && value != null && value.length > 0) {
      const unmatchedElements = genderValue
        .filter((element) => !value.includes(element))
        .concat(value.filter((element) => !genderValue.includes(element)));
      let FinalValue = unmatchedElements;
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'gender';
      });
      FinalValue.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setGenderValue(FinalValue);
    } else {
      setGenderValue([]);
    }
  };

  const handleYearChange = (event, value) => {
    let finalValue = [
      {
        label: 'Year of Birth',
        filter_type: 'yob',
        min: value[0],
        max: value[1],
      },
    ];
    let filterarrayValue1 = filterarrayValue;
    filterarrayValue1 = filterarrayValue1.filter(function (el) {
      return el.filter_type != 'yob';
    });
    finalValue.forEach(function (value1) {
      filterarrayValue1.push(value1);
    });
    setFilterarrayValue(filterarrayValue1);
    setHeaderFilters(filterarrayValue1);
    setYearRange(value);
  };

  const yearText = (value) => {
    return `${value}`;
  };

  const contetualizationChange = (value) => {
    if (value && value != null && value.length > 0) {
      const unmatchedElements = contextualizationValue
        .filter((element) => !value.includes(element))
        .concat(value.filter((element) => !contextualizationValue.includes(element)));
      let FinalValue = unmatchedElements;
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'contetualization';
      });
      FinalValue.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      if (FinalValue.value == 'date_range') {
        handleChangeContetualizationDateRange(contetualizationDateRange);
      }
      if (FinalValue.value != 'benchmark') {
        BrandBenchmarkGroupsChange('', null);
      }
      setContextualizationValue(FinalValue);
    } else {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        // Also drop the date-range entries added when 'date_range' was selected,
        // otherwise they linger after unchecking and keep "Apply" flashing.
        return (
          el.filter_type != 'contetualization' &&
          el.filter_type !== 'contetualizationBenchMark' &&
          el.filter_type !== 'contetualizationFromDate' &&
          el.filter_type !== 'contetualizationToDate'
        );
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setContetualizationBenchmark(null);
      setContextualizationValue([]);
    }
  };

  const getRegionList = ({ name = '', countryIds = [], signal = undefined }) => {
    if (!countryIds.length && !name) return;

    const body = new FormData();
    body.append('page', '1');
    countryIds.forEach((countryId) => body.append('country_id[]', countryId));

    if (name) body.append('term', name);

    ApiProvider.webservicePostToken('Region', body, 'yes', signal).then((response) => {
      if (response.success == true) {
        // an out-of-scope country is answered without `results` (no rows)
        const regionlist = listOf(response.data, 'results');
        const arrRegionList = [];
        regionlist.forEach(function (value) {
          const items = value;
          items['label'] = value.name;
          items['value'] = value.id;
          items['filter_type'] = 'region';
          arrRegionList.push(items);
        });
        setRegionList(arrRegionList);
      } else {
        setRegionList([]);
      }
    });
  };

  const RegionChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'region';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setRegionValue(value);
    } else {
      setRegionValue([]);
    }
  };

  const getCityList = ({ name = '', regionIds = [], signal = undefined }) => {
    if (!regionIds.length && !name) return;

    const body = new FormData();
    body.append('page', '1');
    regionIds.forEach((regionId) => body.append('region_id[]', regionId));

    if (name) body.append('term', name);

    ApiProvider.webservicePostToken('City', body, 'yes', signal).then((response) => {
      if (response.success == true) {
        const citylist = listOf(response.data, 'results');
        const arrCityList = [];
        citylist.forEach(function (value) {
          const items = value;
          items['label'] = value.name;
          items['value'] = value.id;
          items['filter_type'] = 'city';
          arrCityList.push(items);
        });
        setCity_list(arrCityList);
      } else {
        setCity_list([]);
      }
    });
  };

  const CityChange = (value) => {
    if (value && value != null) {
      let filterarrayValue1 = filterarrayValue;
      filterarrayValue1 = filterarrayValue1.filter(function (el) {
        return el.filter_type != 'city';
      });
      value.forEach(function (value1) {
        filterarrayValue1.push(value1);
      });
      setFilterarrayValue(filterarrayValue1);
      setHeaderFilters(filterarrayValue1);
      setCityValue(value);
    } else {
      setCityValue([]);
    }
  };

  const SaveFilterChange = () => {
    if (getHeaderFilters() !== null) {
      setToggleFilterName(!toggleFilterName);
    } else {
      setToggleFilterName(false);
      ApiProvider.globalToastMessage('Please apply filters before trying to save.', 5000, 'error');
    }
  };

  const handleSaveFilter = () => {
    if (filterName.trim() === '') {
      ApiProvider.globalToastMessage('Please enter a filter name.', 5000, 'error');
      return;
    } else {
      const globalSearchValue = getHeaderFilters();
      if (globalSearchValue !== null) {
        let body = new FormData();
        body.append('filterCombination', JSON.stringify(globalSearchValue));
        body.append('filterName', filterName);
        ApiProvider.webservicePostToken('Dashboard/Filters/AddFilters', body, 'yes').then(
          (response) => {
            if (response.success == true) {
              setToggleFilterName(false);
              ApiProvider.globalToastMessage(response.message, 2000, 'success');
            } else {
              ApiProvider.globalToastMessage(response.message, 5000, 'error');
            }
          },
          (error) => {
            ApiProvider.globalToastMessage(error, 5000, 'error');
            return;
          },
        );
      } else {
        ApiProvider.globalToastMessage(
          'Please apply filters before trying to save.',
          5000,
          'error',
        );
      }
    }
  };

  const applyFilters = () => {
    if (filterarrayValue.length > 0) {
      setHeaderFilters(filterarrayValue);
      setPrevFilterArray(filterarrayValue);
      updateGlobalFilters(filterarrayValue);
      onChangeFilters(filterarrayValue);
    } else {
      ApiProvider.globalToastMessage('Please select at least one filter', 5000, 'error');
    }
  };

  const removeFilters = () => {
    setHeaderFilters(null);

    const arrCurrency = filterCurrency;
    if (
      ApiProvider.returnUserData()?.currency_id &&
      ApiProvider.returnUserData()?.currency_id != null
    ) {
      const check = arrCurrency.findIndex(
        (el) => el.id == ApiProvider.returnUserData()?.currency_id,
      );
      setCurrency_value([arrCurrency[check]]);
    } else {
      const check1 = arrCurrency.findIndex((el) => el.currency_code == 'USD');
      setCurrency_value([arrCurrency[check1]]);
    }

    setCountryValue([]);
    setBrandValue([]);
    setPropertyValue([]);
    setActivationtypeValue([]);
    setActivationSubypeValue([]);
    setActivationSubTouchpointValue([]);
    setActivationAssetValue([]);
    setActivationItemValue([]);
    setActivationMediumValue([]);
    setActivationSegmentValue([]);
    setDqsValue([]);
    setGenderValue([]);
    setYearRange([minYob, maxYob]);
    setRegionValue([]);
    setCityValue([]);
    setDateRange([startOfYear(new Date()), new Date()]);
    let oneDayAgo = new Date(startOfYear(new Date()).getTime() - 24 * 60 * 60 * 1000);
    setContextualizationValue([]);
    setContetualizationDateRange([oneDayAgo, oneDayAgo]);
    setContetualizationBenchmark(null);
    setAfterDateDisable(oneDayAgo);
    setFilterarrayValue(defaultFilters);

    updateGlobalFilters(defaultFilters);
    onChangeFilters(defaultFilters);
    setPrevFilterArray(defaultFilters);
  };

  useEffect(() => {
    // the selection in memory (selection/headerSelection.ts): the last one the server
    // keeps for the role, else the default saved filter; none: this header's defaults
    const globalFiltersLocalStorage = getHeaderFilters();

    if (!globalFiltersLocalStorage) {
      setHeaderFilters(defaultFilters);
    } else {
      try {
        let checkData = globalFiltersLocalStorage.filter(function (el) {
          return el.filter_type == 'contetualization';
        });
        if (checkData.length > 0 && checkData[0].value == 'benchmark') {
          let globalSearchDataNew = globalFiltersLocalStorage.filter(function (el) {
            return el.filter_type != 'contetualization';
          });
          setHeaderFilters(globalSearchDataNew);
        }

        let checkData1 = globalFiltersLocalStorage.filter(function (el) {
          return el.filter_type == 'contetualizationBenchMark';
        });
        if (checkData1.length > 0) {
          let globalSearchDataNew = globalFiltersLocalStorage.filter(function (el) {
            return el.filter_type != 'contetualizationBenchMark';
          });
          setHeaderFilters(globalSearchDataNew);
        }
      } catch (e) {
        console.error(e);
      }
    }

    const data = globalFiltersLocalStorage ? getHeaderFilters() : defaultFilters;

    setFilterarrayValue(data);

    setTimeout(() => {
      updateGlobalFilters(data);
      onChangeFilters(data);
      setPrevFilterArray(data);
    }, 300);

    //currency
    const curencyArray = data.filter(function (el) {
      return el.filter_type == 'currency';
    });
    setCurrency_value(curencyArray);

    //Date
    const fromArr = data.filter(function (el) {
      return el.filter_type == 'from';
    });
    const toArr = data.filter(function (el) {
      return el.filter_type == 'to';
    });
    if (fromArr.length > 0 && toArr.length > 0) {
      const fromDate1 = new Date(fromArr[0].name);
      const toDate1 = new Date(toArr[0].name);
      setDateRange([fromDate1, toDate1]);

      let oneDayAgo = new Date(fromDate1.getTime() - 24 * 60 * 60 * 1000);
      setContetualizationDateRange([oneDayAgo, oneDayAgo]);
      setAfterDateDisable(oneDayAgo);
    }

    // Contetualization Date

    const contetualizationFromDateArray = data.filter(function (el) {
      return el.filter_type == 'contetualizationFromDate';
    });
    const contetualizationToDateArray = data.filter(function (el) {
      return el.filter_type == 'contetualizationToDate';
    });
    if (contetualizationFromDateArray.length > 0 && contetualizationToDateArray.length > 0) {
      const fromDate1 = new Date(contetualizationFromDateArray[0].name);
      const toDate1 = new Date(contetualizationToDateArray[0].name);
      setContetualizationDateRange([fromDate1, toDate1]);
    }

    //country

    const countryArr = data.filter(function (el) {
      return el.filter_type == 'country';
    });
    setCountryValue(countryArr);

    //Brand
    const brandArr = data.filter(function (el) {
      return el.filter_type == 'brand';
    });
    setBrandValue(brandArr);

    //Property
    const propertyArr = data.filter(function (el) {
      return el.filter_type == 'property';
    });
    setPropertyValue(propertyArr);

    //Activation Type
    const activationTypeArr = data.filter(function (el) {
      return el.filter_type == 'activationType';
    });
    setActivationtypeValue(activationTypeArr);

    //ActivationSub Type
    const activationSubTypeArr = data.filter(function (el) {
      return el.filter_type == 'activationSubtype';
    });
    setActivationSubypeValue(activationSubTypeArr);

    //ActivationSub-Touchpoint Type
    const activationSubTouchpointArr = data.filter(function (el) {
      return el.filter_type == 'activationSubTouchpoint';
    });
    setActivationSubTouchpointValue(activationSubTouchpointArr);

    //Activation Asset
    const activationAssetArr = data.filter(function (el) {
      return el.filter_type == 'activationAsset';
    });
    setActivationAssetValue(activationAssetArr);

    //ActivationSub Type
    const activationItemArr = data.filter(function (el) {
      return el.filter_type == 'activationItem';
    });
    setActivationItemValue(activationItemArr);

    //Activation Medium
    const activationMedArr = data.filter(function (el) {
      return el.filter_type == 'activationMedium';
    });
    setActivationMediumValue(activationMedArr);

    //Activation Segment
    const activationSegArr = data.filter(function (el) {
      return el.filter_type == 'consumerSegment';
    });
    setActivationSegmentValue(activationSegArr);

    // Dqs
    const dqsArr = data.filter(function (el) {
      return el.filter_type == 'dqs';
    });
    setDqsValue(dqsArr);

    // Gender
    const genderArr = data.filter(function (el) {
      return el.filter_type == 'gender';
    });
    setGenderValue(genderArr);

    // Yob
    const yobArr = data.filter(function (el) {
      return el.filter_type == 'yob';
    });
    if (yobArr.length > 0) {
      setYearRange([yobArr[0].min, yobArr[0].max]);
    }

    //Contetualization
    const contetualizationArr = data.filter(function (el) {
      return el.filter_type == 'contetualization';
    });
    setContextualizationValue(contetualizationArr);

    //Region
    const regionArr = data.filter(function (el) {
      return el.filter_type == 'region';
    });
    setRegionValue(regionArr);

    //City
    const cityArr = data.filter(function (el) {
      return el.filter_type == 'city';
    });
    setCityValue(cityArr);

    currencyValue();
    getActivationFiltersValues();
    getDqsValues();
    getGenderValues();
    getCountryList();
    if (currentPageName == 'brandprofile' || currentPageName == 'partnerProfile') {
      getBenchmark();
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();

    getCityList({
      name: citySearchQuery,
      regionIds: regionValue.map((region) => region.id),
      signal: controller.signal,
    });

    return () => {
      controller.abort();
    };
  }, [citySearchQuery, regionValue]);

  useEffect(() => {
    const controller = new AbortController();

    getRegionList({
      name: regionSearchQuery,
      countryIds: countryValue.map((country) => country.id),
      signal: controller.signal,
    });

    return () => {
      controller.abort();
    };
  }, [regionSearchQuery, countryValue]);

  useEffect(() => {
    const controller = new AbortController();

    setPropertyOffset(0);
    setPropertyHasMore(true);
    getPropertyList(true, propertySearchQuery, controller.signal);

    return () => {
      controller.abort();
    };
  }, [propertySearchQuery]);

  const additionalFilters = isCityRegionEnabled
    ? [
      {
        label: 'Region',
        value: regionValue,
        options: region_list,
        onChange: RegionChange,
        displayStatus: returnDisplayStatus('Region'),
        isDisabled: isRegionDisabled,
        helperText: isRegionDisabled ? 'Please select a country first' : undefined,
        filterOptions: setRegionSearchQuery,
      },
      {
        label: 'City',
        value: cityValue,
        options: city_list,
        onChange: CityChange,
        displayStatus: returnDisplayStatus('City'),
        isDisabled: isCityDisabled,
        helperText: isCityDisabled ? 'Please select a region first' : undefined,
        filterOptions: setCitySearchQuery,
      },
    ]
    : [];

  const accordionsObject = [
    {
      label: 'Currency',
      value: currency_value,
      options: currency_value.concat(currencyfltOptions),
      onChange: CurrencyChange,
      displayStatus: currentTabName !== 'scouting',
      showOnTop: true,
    },
    {
      label: 'Country',
      ...(countryIsDataMarket
        ? { title: t(DATA_MARKET_LABEL_KEY), tooltip: t(DATA_MARKET_TOOLTIP_KEY) }
        : {}),
      value: countryValue,
      options: countryValue.concat(countryfltOptions),
      onChange: CountryChange,
      displayStatus: true,
    },
    {
      label: 'Brand',
      value: brandValue,
      options: brandValue.concat(brandfltOptions),
      displayStatus: currentTabName !== 'scouting',
      filterOptions: setBrandSearchQuery,
      onLoadMore: loadMoreBrandOptions,
      onChange: BrandChange,
      // Single-brand pages (ROO, advocacy, §13.4): the page's one brand is
      // the brand; the multi-select filter is hidden and never sent.
      ...(isSingleBrandPage ? { displayStatus: false } : {}),
    },
    {
      label: 'Right Holder/Partner',
      value: propertyValue,
      options: propertyValue.concat(propertyfltOptions),
      onChange: PropertyChange,
      filterOptions: setPropertySearchQuery,
      onLoadMore: loadMorePropertyOptions,
      displayStatus: true,
    },
    {
      label: 'Activity Type',
      value: activationtypeValue,
      options: activationtype_list,
      displayStatus: returnDisplayStatus('Activity Type'),
      onChange: ActivationTypeChange,
    },
    {
      label: 'Touchpoint',
      value: activationSubypeValue,
      options: activationSubtype_list,
      displayStatus: returnDisplayStatus('Touchpoint'),
      onChange: ActivationSubTypeChange,
    },
    {
      label: 'Sub-Touchpoint',
      value: activationSubTouchpointValue,
      options:
        activationSubypeValue.length > 0
          ? removeDuplicates(
            filterSubTouchpoint(activationSubTouchpointList, activationSubypeValue),
          )
          : removeDuplicates(activationSubTouchpointList),
      displayStatus: false,
      onChange: activationSubTouchpointChange,
    },
    {
      label: 'Asset',
      value: activationAssetValue,
      options: activationAssetList,
      displayStatus: false,
      onChange: activationAssetChange,
    },
    {
      label: 'Item',
      value: activationItemValue,
      options: activationItemList,
      displayStatus: false,
      onChange: activationItemChange,
    },
    {
      label: 'Activity Medium',
      value: activationMediumValue,
      options: activationMedium_list,
      displayStatus: returnDisplayStatus('Activity Medium'),
      onChange: ActivationMediumChange,
    },
    {
      label: 'Consumer Segment',
      value: activationSegmentValue,
      options: activationSegment_List,
      displayStatus: returnDisplayStatus('Consumer Segment'),
      onChange: ActivationSegmentChange,
    },
    {
      label: 'DQS',
      value: dqsValue,
      options: dqsList,
      isDisabled: isDqsDisabled,
      displayStatus: currentTabName !== 'scouting',
      onChange: dqsChange,
    },
    {
      label: 'Gender',
      value: genderValue,
      options: genderList,
      displayStatus: returnDisplayStatus('Gender'),
      onChange: genderChange,
    },
    {
      label: 'Year of Birth',
      value: yearRange,
      options: {},
      displayStatus: returnDisplayStatus('Year of Birth'),
      onChange: handleYearChange,
    },
    {
      label: 'Contextualization',
      value: contextualizationValue,
      options: contextualizationList,
      displayStatus: currentTabName !== 'scouting',
      onChange: contetualizationChange,
    },
    ...additionalFilters,
  ];

  return (
    <>
      {/* NEW FILTERS. */}
      <Box
        className='header__filters'
        sx={{
          boxSizing: 'border-box',
          backgroundColor: 'primary.main',
          position: 'fixed',
          top: '0',
          height: '50px',
          width: headerWidth,
          left: `${headerLeftOffset}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          zIndex: '1302',
          overflowX: 'clip',
          transition: 'left .28s ease, width .28s ease',
        }}
      >
        {/* Left side buttons (Home + Search). */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'primary.main',
            gap: '16px',
            padding: '0 28px 0 20px',
            maxWidth: '56%',
            flex: '1 1 56%',
            position: 'relative',
            boxSizing: 'border-box',
          }}
        >
          {/* Home link. */}
          <SidebarLink
            to={homePageUrl}
            icon={HomeIcon}
            boxContainerStyles={{
              ...linkWithBGStyles,
              border: '1px solid',
              borderColor: 'typography.main',
              borderRadius: '40px',
              padding: '2px 10px !important',
              marginTop: '0',
            }}
          />

          {/* Global search. */}
          <Box className='header__filters__search' sx={{ width: '80%' }}>
            <Box sx={{ position: 'relative' }}>
              <GlobalSearchBar
                placeholder={'Search...'}
                iconPosition='start'
                variant='header'
                ContainerStyles={searchContainerStyles}
                InputStyles={{
                  paddingLeft: '0',
                }}
                ScrollbarsStyles={{
                  position: 'absolute',
                  marginTop: '0',
                  top: '40px',
                  left: '0',
                  zIndex: '999',
                  height: 'min(70vh, 600px)',
                  boxShadow: 'shadows[5]',
                  backgroundColor: 'tertiary.main',
                  borderRadius: '4px',
                }}
              />
            </Box>
          </Box>

        </Box>

        {/* Right side buttons (Calendar + Filters). */}
        <Box
          pr={2}
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            maxWidth: '56%',
            width: 'auto',
            minWidth: 0,
            flex: '1 1 auto',
            height: '100%',
            backgroundColor: 'tertiary.dark',
          }}
        >
          {/* S-curve leading edge — flows the filter panel into the header */}
          <Box
            component='svg'
            viewBox='0 0 50 50'
            preserveAspectRatio='none'
            sx={{
              position: 'absolute',
              left: '-50px',
              top: 0,
              width: '50px',
              height: '100%',
              display: 'block',
              pointerEvents: 'none',
              color: 'tertiary.dark',
            }}
          >
            <path d='M 50,0 L 35,0 C 0,12 50,38 15,50 L 50,50 Z' fill='currentColor' />
          </Box>

          <Box
            className='header__filters__selects'
            sx={{
              pl: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginLeft: 'auto',
              position: 'relative',
              transform: showAdvancedFilters ? 'translateY(-50px)' : 'translateY(0)',
              transition: 'transform .3s',
              '.desktop-top': {
                '@media (max-width: 1350px)': {
                  display: 'none',
                },
              },
            }}
          >
            {/* Date picker. */}
            <Box
              className='header__filters__date'
              sx={{
                // Keep the wrapper transparent so only the rounded pill (the
                // OutlinedInput) shows a white fill — no white rectangle behind it.
                '& > div': {
                  backgroundColor: 'transparent',
                },
              }}
            >
              <GlobalDateRangePicker
                value={dateRange}
                shortcuts={availableShortcutDates}
                onAccept={handleChangeDateRange}
              />
            </Box>

            {/* Dropdowns. */}
            {accordionsObject
              .filter((item) => item.showOnTop)
              .map(({ label, value, options, onChange, filterOptions }) => {
                const filterOptionsProps = filterOptions
                  ? {
                    filterOptions: (options, filter) => {
                      if (filterOptions) {
                        if (!!filter) {
                          filterOptions(filter);
                        } else {
                          filterOptions('');
                        }
                      }
                      return options;
                    },
                  }
                  : {};

                return (
                  <Badge
                    key={label}
                    badgeContent={value.length}
                    className='desktop-top'
                    ml='10px'
                    sx={{
                      ml: '10px',
                      '.rmsc .dropdown-container': {
                        backgroundColor: 'tertiary.main',
                      },
                    }}
                  >
                    <MultiSelectBox
                      options={options}
                      value={value}
                      onChange={onChange}
                      ArrowRenderer={ArrowDropDownIcon}
                      overrideStrings={{
                        selectSomeItems: label,
                      }}
                      className=' multiSelectFilter header-select-item'
                      hasSelectAll={false}
                      {...filterOptionsProps}
                    />
                  </Badge>
                );
              })}
          </Box>

          {/* Advanced filters trigger. */}
          <Box className='header__filters__advanced-trigger'>
            <div className='filter_badge'>
              <Button
                variant='outlined'
                className='top_filter_btn'
                color='primary'
                onClick={handleAdvancedFiltersToggleClick}
                startIcon={<FilterAltIcon />}
                sx={{
                  width: '150px',
                  borderColor: 'primary.main',
                  backgroundColor: 'tertiary.main',
                }}
              >
                {showAdvancedFilters ? 'Close filters' : 'More filters'}
              </Button>
              <Badge
                badgeContent={totalFilterVal}
                color='primary'
                className='count_item_advfilter'
              ></Badge>
            </div>
          </Box>

          {/* Apply / Reset. */}
          <Box className='header__filters__cta' display='flex' gap={2}>
            {animateHeartBeat && (
              <Button
                variant='contained'
                className='top_filterbtn changed' // commented this line as it was animating on every route change.
                onClick={applyFilters}
                sx={{
                  backgroundColor: '#121d33',
                  textTransform: 'Capitalize',
                }}
              >
                Apply
              </Button>
            )}

            {Boolean(filterarrayValue.length > 0) && (
              <Tooltip title={'Reset filters'}>
                <Button
                  variant='contained'
                  color='tertiary'
                  onClick={removeFilters}
                  sx={{
                    minWidth: 'unset',
                  }}
                >
                  <ReplayIcon fontSize='small' />
                </Button>
              </Tooltip>
            )}
          </Box>
        </Box>
      </Box>

      <Box
        className='open_filter'
        id='filter_pannel'
        sx={{
          backgroundColor: 'tertiary.dark',
          height: 'calc(100vh - 50px)',
          position: 'fixed',
          overflow: 'scroll',
          top: '50px',
          left: `${headerLeftOffset}px`,
          maxHeight: showAdvancedFilters ? '999px' : '0px',
          width: `calc(100% - ${headerLeftOffset}px)`,
          transition: 'max-height .3s',
          zIndex: 1301,
        }}
      >
        <Box
          sx={{
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          {/* CTAs. */}
          <Box
            className='advanced-filters__cta'
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '8px',
            }}
          >
            <SavedFiltersPopUp />
            <Button
              variant='contained'
              color='primary'
              onClick={() => SaveFilterChange()}
              sx={{
                textTransform: 'initial',
                fontWeight: '500',
              }}
            >
              <SaveIcon sx={{ mr: '8px' }} />
              Save filter
            </Button>
          </Box>

          {/* Save current filter Input + Submit. */}
          {toggleFilterName && (
            <Box className='ScrollbarsAdvancedFilters'>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  type='text'
                  placeholder='Enter filter name'
                  value={filterName}
                  onChange={(e) => setFilterName(e.target.value)}
                  style={{ padding: '5px', flex: 1 }}
                />
                <IconButton
                  color='primary'
                  onClick={handleSaveFilter}
                  style={{ marginLeft: '10px', backgroundColor: '#121d33', color: 'white' }}
                >
                  <SaveIcon />
                </IconButton>
              </div>
            </Box>
          )}

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            {/* Filters content. */}
            <HeaderAdvancedFilters>
              {accordionsObject
                .filter((item) => item.displayStatus)
                .map(
                  ({
                    label,
                    title = label,
                    tooltip = '',
                    value,
                    options,
                    onChange,
                    filterOptions,
                    onLoadMore,
                    isDisabled = false,
                    helperText = '',
                  }) => {
                    const filterOptionsProps = filterOptions
                      ? {
                        filterOptions: (options, filter) => {
                          if (filterOptions) {
                            if (!!filter) {
                              filterOptions(filter);
                            } else {
                              filterOptions('');
                            }
                          }
                          return options;
                        },
                      }
                      : {};

                    return (
                      <AdvancedFilterOption
                        className={'advanced-filters__content__select'}
                        key={label}
                      >
                        <Tooltip title={tooltip} placement='top' arrow>
                          <Typography
                            sx={{
                              padding: '4px 15px',
                              backgroundColor: 'primary.main',
                              color: '#fff',
                              borderRadius: '5px 5px 0 0',
                            }}
                          >
                            {title}
                          </Typography>
                        </Tooltip>

                        {!!helperText && (
                          <Typography as={'p'} sx={{ padding: '8px 15px', fontSize: '12px' }}>
                            {helperText}
                          </Typography>
                        )}

                        {label == 'Year of Birth' ? (
                          <Box sx={{ width: '100%', height: '250px', padding: '20% 50% 20%' }}>
                            <Slider
                              value={value}
                              onChange={(event, value) => onChange(event, value)}
                              valueLabelDisplay='on'
                              orientation='vertical'
                              aria-labelledby={label}
                              valueLabelFormat={yearText}
                              min={minYob}
                              max={maxYob}
                              step={1}
                              marks
                            />
                          </Box>
                        ) : (
                          <div
                            // react-multi-select-component's dropdown list scrolls
                            // internally, and the native "scroll" event does not
                            // bubble, so we must listen on the capture phase to
                            // detect scrolling and trigger loading the next page.
                            onScrollCapture={(event) => {
                              if (!onLoadMore) return;
                              const { scrollTop, scrollHeight, clientHeight } = event.target;
                              const isNearBottom =
                                scrollHeight - scrollTop <= clientHeight + 100;
                              if (isNearBottom) {
                                onLoadMore();
                              }
                            }}
                          >
                            <MultiSelect
                              options={options}
                              value={value}
                              isOpen={true}
                              onChange={(value) => onChange(value)}
                              disabled={isDisabled}
                              debounceDuration={1000}
                              hasSelectAll={false}
                              {...filterOptionsProps}
                            />
                          </div>
                        )}

                        {value.length >= 1 && (
                          <Badge
                            badgeContent={value.length}
                            color='primary'
                            className='count_item_advfilter'
                            sx={{
                              position: 'absolute',
                              top: '0  !important',
                              right: '2px !important',
                            }}
                          />
                        )}

                        {Boolean(
                          label == 'Contextualization' &&
                          contextualizationValue.length > 0 &&
                          contextualizationValue[0].value == 'date_range',
                        ) && (
                            <div className='contetualization_date_range relative_div'>
                              <GlobalDateRangePicker
                                value={contetualizationDateRange}
                                onAccept={handleChangeContetualizationDateRange}
                                maxDate={afterDateDisable}
                                applyOnSelect
                              />
                            </div>
                          )}

                        {Boolean(
                          label == 'Contextualization' &&
                          contextualizationValue.length > 0 &&
                          contextualizationValue[0].value == 'benchmark',
                        ) && (
                            <div className='contetualization_date_range'>
                              {currentPageName == 'brandprofile' ||
                                currentPageName == 'partnerProfile' ? (
                                <Autocomplete
                                  className='full-width'
                                  size='small'
                                  value={contetualizationBenchmark}
                                  options={benchmarkGroupsList}
                                  onChange={BrandBenchmarkGroupsChange}
                                  getOptionLabel={(option) => (option ? option.benchmark_name : '')}
                                  renderInput={(params) => (
                                    <TextField {...params} label='Benchmark' variant='outlined' />
                                  )}
                                />
                              ) : (
                                'The Benchmark filter is only available for Brand and Right Holder/Partner profiles.'
                              )}
                            </div>
                          )}
                      </AdvancedFilterOption>
                    );
                  },
                )}
            </HeaderAdvancedFilters>
          </Box>
        </Box>
      </Box>
    </>
  );
}

const availableShortcutDates = [
  {
    label: 'Last 1 Month',
    acronym: '1M',
    placement: 'left',
    value: [startOfMonth(subMonths(new Date(), 1)), new Date()],
  },
  {
    label: 'Last 3 Months',
    acronym: '3M',
    placement: 'left',
    value: [startOfMonth(subMonths(new Date(), 3)), new Date()],
  },
  {
    label: 'Last 6 Months',
    acronym: '6M',
    placement: 'left',
    value: [startOfMonth(subMonths(new Date(), 6)), new Date()],
  },
  {
    label: 'Last 1 Year',
    acronym: '1Y',
    placement: 'left',
    value: [startOfMonth(subYears(new Date(), 1)), new Date()],
  },
  {
    label: 'Last 2 Years',
    acronym: '2Y',
    placement: 'left',
    value: [startOfMonth(subYears(new Date(), 2)), new Date()],
  },
  {
    label: 'Previous Year',
    acronym: 'PY',
    placement: 'left',
    value: [startOfYear(subYears(new Date(), 1)), endOfYear(subYears(new Date(), 1))],
  },
  {
    label: 'Year To Date',
    acronym: 'YTD',
    placement: 'left',
    value: [startOfYear(new Date()), new Date()],
  },
  {
    label: 'Current Year',
    acronym: 'CY',
    placement: 'left',
    value: [startOfYear(new Date()), endOfYear(new Date())],
  },
];

const contextualizationList = [
  {
    label: 'Year Over Year',
    value: 'year_over_year',
    filter_type: 'contetualization',
  },
  {
    label: 'Quarter Over Quarter',
    value: 'quater_over_quater',
    filter_type: 'contetualization',
  },
  {
    label: 'Date Range',
    value: 'date_range',
    filter_type: 'contetualization',
  },
  {
    label: 'Benchmark',
    value: 'benchmark',
    filter_type: 'contetualization',
  },
];

const oneDayAgoNew = new Date(startOfYear(new Date()).getTime() - 24 * 60 * 60 * 1000);

export default HeaderFilters;
